import { apiClient } from '../utils/ApiClient'
import { PremiumPlanTierList } from '../utils/Interfaces'

export const apiFetchPlanTierListObject = async (): Promise<PremiumPlanTierList> => {
  const response = await apiClient.get('/plan_tier_list_object')
  return response.data
}
